import request from '@/util/request';
//测试
export const test = (params, options) =>
    request.get('/test', Object.assign({}, options, { params }));
// 字典数据
export const getDict = (params, options) =>
    request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }));
//项目列表
export const getProjectList = (params, options) =>
    request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));
export const inboundSave = (params, options) =>
    request.post('/api/v4ward/warehouse/inbound/submit', params, options);
//汇总金额
export const getPriceSum = (params, options) =>
    request.get('/api/v4ward/warehouse/requisition/outbound/getPriceSum', Object.assign({}, options, { params }));
//申请单列表
export const warehouseRequisitionPage = (params, options) =>
    request.get('/api/v4ward/warehouse/requisition/outbound/page', Object.assign({}, options, { params }));
//项目下用户列表 带搜索
export const getProjectUserList = (params, options) =>
    request.get('/api/v4ward/user/project-user-list', Object.assign({}, options, { params }))
//申领单基础信息
export const warehouseRequisitionDetail = (params, options) =>
    request.get('/api/v4ward/warehouse/requisition/detail', Object.assign({}, options, { params }))
//申领单货品详情
export const getConsumableListByRequisitionOutboundId = (params, options) =>
    request.get('/api/v4ward/warehouse/requisition/consumable/getConsumableListByRequisitionOutboundId', Object.assign({}, options, { params }))
// 获取项目下的科室列表
export const treeByProjectDeptId = (params, options) =>
    request.get('/api/v4ward/dept/treeByProjectDeptId', Object.assign({}, options, { params }))
// 出库金额计算
export const consumableCalculate = (params, options) =>
    request.get('/api/v4ward/warehouse/outbound/consumable/calculate', Object.assign({}, options, { params }))
// 领用出库提交
export const outboundSave = (params, options) =>
    request.post('/api/v4ward/warehouse/requisition/outbound/requisitionOutbound', params, options);
//关单
export const closeTheSingle = (params, options) =>
    request.post('/api/v4ward/warehouse/requisition/outbound/closeTheSingle', params, options);